import i18n, { SUPPORTED_LOCALES } from '@/utils/i18n'

export { SUPPORTED_LOCALES }

const STORAGE_KEY = 'APP_LOCALE'

export function resolveDefaultLocaleByCurrency (currency) {
  const raw = String(currency || '').trim()
  const code = raw.toUpperCase()

  if (code === 'KRW' || raw === '₩' || code === 'WON' || raw === '원') {
    return 'ko'
  }
  if (code === 'USD' || raw === '$') {
    return 'en'
  }
  if (code === 'JPY' || raw === '¥' || raw === '￥' || code === 'YEN' || raw === '円') {
    return 'ja'
  }
  if (code === 'CNY' || code === 'RMB' || raw === '元' || raw === '人民币') {
    return 'zh'
  }

  return 'en'
}

function hasSavedLocale () {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY)
    return !!(saved && SUPPORTED_LOCALES.indexOf(saved) !== -1)
  } catch (e) {
    return false
  }
}

export function applyLocaleFromSiteCurrency (siteInfo) {
  if (hasSavedLocale()) return false

  const currency = siteInfo && siteInfo.currency != null
    ? String(siteInfo.currency).trim()
    : ''

  return setAppLocale(resolveDefaultLocaleByCurrency(currency))
}

export const APP_LOCALES = [
  { code: 'ko', label: '한국어', short: 'KO', flag: '🇰🇷' },
  { code: 'en', label: 'English', short: 'EN', flag: '🇺🇸' },
  { code: 'zh', label: '中文', short: 'ZH', flag: '🇨🇳' },
  { code: 'ja', label: '日本語', short: 'JA', flag: '🇯🇵' }
]

export function getCurrentLocale () {
  return i18n.locale
}

export function getLocaleMeta (code) {
  return APP_LOCALES.find(item => item.code === code) || APP_LOCALES[0]
}

export function setAppLocale (code) {
  const next = String(code || '').toLowerCase()
  if (SUPPORTED_LOCALES.indexOf(next) === -1) return false
  i18n.locale = next
  try {
    window.localStorage.setItem(STORAGE_KEY, next)
  } catch (e) { /* ignore */ }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = next
  }
  return true
}

export function translateNavItems (items, t) {
  if (!Array.isArray(items)) return []
  const translate = typeof t === 'function' ? t : key => key
  return items.map(item => {
    if (!item || !item.labelKey) return item
    return {
      ...item,
      label: translate(item.labelKey)
    }
  })
}
